/**
 * Create Articles context for custom hook
 */

import { createContext } from 'react'

const ArticlesContext = createContext({
  fetchArticles: () => {},
  fetchArticle: () => {},
  fetchArticlesTags: () => {}
})

export default ArticlesContext
